import { Popular, Veggie } from "../components/index";


function Home() {
    return (
        <div>
            <Popular />
            <Veggie />
        </div>
    )
}

export default Home